let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8tbRj")).then(() => parcelRequire('3ifTP'));